import React, { createContext, useContext, useState } from "react";
import { API_URL } from "../lib/_base";

export interface LibraryConfig {
  apiKey: string | null;
  websocketUrl: URL;
  activeMode: 'chat' | 'call' | null
  muted?: boolean;
  verbose?: boolean;
  current_language?: string;
  remote?: {
    character: {
      name: string;
      avatar?: string;
      stt: boolean;
      tts: boolean;
    }
    tools: Record<string, any>
    ui_variant?: string;
    language_settings?: {
      default_language: string;
      supported_languages: string[];
    }
  }
}

export const defaultConfig: LibraryConfig = {
  apiKey: null,
  verbose: false,
  websocketUrl: new URL("/ws", API_URL),
  activeMode: null,
}

type ConfigContextType = {
  config: LibraryConfig;
  getConfig: () => LibraryConfig;
  updateConfig: (updates: Partial<LibraryConfig>) => void;
}

export const LibraryConfigContext = createContext<ConfigContextType>({
  config: defaultConfig,
  getConfig() { return defaultConfig },
  updateConfig() { },
})

type LibraryContextProviderProps = {
  children: React.ReactNode;
  initialConfig?: Partial<LibraryConfig>;
}
export function LibraryContextProvider({ children, initialConfig = {} }: LibraryContextProviderProps) {
  const [config, setConfig] = useState({ ...defaultConfig, ...initialConfig });

  function updateConfig(updates: Partial<LibraryConfig>) {
    console.log('updateConfig', { updates })
    setConfig(p => {
      const nUpdates = { ...p, ...updates }
      if (typeof updates.apiKey === 'string') {
        nUpdates.websocketUrl.pathname = `/ws/${updates.apiKey}`
      }
      return nUpdates
    })
  }

  return (
    <LibraryConfigContext.Provider
      value={{
        config,
        updateConfig,
        getConfig: () => config,
      }}>
      {children}
    </LibraryConfigContext.Provider>
  )
}

// This simplifies accessing the context in consuming components
export const useConfig = (): ConfigContextType => {
  const context = useContext(LibraryConfigContext);
  // Ensure the hook is used within a provider
  if (context === undefined) {
    throw new Error("useConfig must be used within a LibraryContextProvider");
  }
  return context;
};
